if(typeof BSS_B2B) {
  if(window.location.pathname.includes("/account/register")) {
    setTimeout(() =>{
      let textField = $('.formbuilder-text');
      let textfieldAlias = $('.rendered-form .formbuilder-text:first-child');
      let lastName = $('#LastName');
      if(textField.length) {
          textField.each((ind, item)=>{
            const input = $(item).find("input");
            const label = $(item).find("label");
            if (input && label) {
              $(label).addClass("label--hidden");
            }
          })  
      }

      if(textfieldAlias && lastName) {
        lastName.after(textfieldAlias)
      }
    }, 200)
  }
  // if(window.location.pathname.includes("/products")) {
  //   setTimeout(() =>{
  //     BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), '[bss-b2b-product-id]',false, false);
  //   }, 300)
  // }
  
}
let timeBack = 10;
const handleF = () => {
  const target = $(".swatchColor");  
  if (target.length > 0) {
    $(target).on("click", () => {
      setTimeout(() => {
          const urlParams = new URLSearchParams(new URL(window.location.href).search);
          const variantValue = urlParams.get('variant');
          BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), "[bss-b2b-variant-id]", false, false, variantValue);
      }, 200)
    })
  }
  else if (timeBack-- > 0) setTimeout(handleF, 300);
}
handleF();
